module.exports = __webpack_public_path__ + "static/img/a062.85ea3f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a062.jpg
// module id = AC+Y
// module chunks = 0